import { UserDetailInstancesState, UserDetailState } from "./interface";
import { initialState as singleInstanceInitialState } from "./initialState";

export const clone = <T>(obj: T): T => JSON.parse(JSON.stringify(obj));

export const DEFAULT_CTX = 'main';

export const getCtxFromAction = (action: any): string => {
  const ctx = action?.meta?.arg?.contextKey ?? DEFAULT_CTX;
  if (ctx === 'main') {
    console.warn('⚠️ Acción sin contextKey detectada:', action.type);
  }
  return ctx;
};

export const makeInstance = (): UserDetailState => clone(singleInstanceInitialState);

export const getInstance = (state: UserDetailInstancesState, ctx: string): UserDetailState => {
  if (!state.instances[ctx]) {
    state.instances[ctx] = makeInstance();
  }
  return state.instances[ctx];
};